import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PaymentsService } from '../../services/payments.service';

export interface VendorRemitPreviewTabRequest {
	label: string;
	supplier_id: string;
	context: Record<string, unknown>;
	allocations: Array<{ trans_id: number; amount: number }>;
}

export interface VendorRemitPreviewModalData {
	title: string;
	tabs: VendorRemitPreviewTabRequest[];
}

export interface VendorRemitPreviewResponse {
	success: boolean;
	message?: string;
	html?: string;
	warnings?: string[];
	recipient_email?: string;
	subject?: string;
}

@Component({
	selector: 'app-vendor-remit-preview-modal',
	templateUrl: './vendor-remit-preview-modal.component.html',
	styleUrls: ['./vendor-remit-preview-modal.component.scss']
})
export class VendorRemitPreviewModalComponent implements OnInit {
	loading = true;
	/** One entry per tab; trustedHtml null if no body */
	results: Array<{
		label: string;
		res: VendorRemitPreviewResponse;
		trustedHtml: SafeHtml | null;
	}> = [];

	constructor(
		public dialogRef: MatDialogRef<VendorRemitPreviewModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: VendorRemitPreviewModalData,
		private paymentsService: PaymentsService,
		private sanitizer: DomSanitizer
	) {}

	ngOnInit(): void {
		if (!this.data.tabs || this.data.tabs.length === 0) {
			this.loading = false;
			return;
		}
		const reqs = this.data.tabs.map((t) =>
			this.paymentsService.previewVendorRemittanceLive({
				supplier_id: t.supplier_id,
				context: t.context,
				allocations: t.allocations
			}).pipe(
				catchError(() =>
					of({
						success: false,
						warnings: ['Could not load preview.']
					} as VendorRemitPreviewResponse)
				)
			)
		);
		forkJoin(reqs).subscribe((responses: VendorRemitPreviewResponse[]) => {
			this.loading = false;
			this.results = this.data.tabs.map((t, i) => {
				const res = responses[i] || { success: false, warnings: ['Missing response'] };
				const trusted =
					res.success && res.html
						? this.sanitizer.bypassSecurityTrustHtml(res.html)
						: null;
				return { label: t.label, res, trustedHtml: trusted };
			});
		});
	}

	close(): void {
		this.dialogRef.close();
	}
}
